import { LanguageSwitcher } from "./language-switcher";
import { NotificationBell } from "@/components/notifications/notification-bell";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/theme-toggle";
import { cn } from "@/lib/utils";

interface SiteHeaderProps {
  className?: string;
}

export function SiteHeader({ className }: SiteHeaderProps) {
  return (
    <header className={cn("flex h-16 shrink-0 items-center gap-4 border-b bg-background px-4 transition-[width] ease-linear lg:px-6", className)}>
      <SidebarTrigger />
      <Separator orientation="vertical" className="mx-2 hidden h-4 md:block" />
      <div className="ml-auto flex items-center gap-x-2">
        <NotificationBell />
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
    </header>
  );
}
